// =====================================================================
//  CONFIGURACIÓN DE MARCA — Personalización por cliente
// =====================================================================
//
//  ESTE ES EL ÚNICO ARCHIVO QUE HAY QUE EDITAR para adaptar el sistema
//  a un cliente nuevo (nombre, logo, colores y datos de la empresa).
//
//  Para los COLORES, además de este archivo hay que editar las variables
//  de color en `src/main.css` (busca la sección "COLORES DE MARCA").
//
// =====================================================================

export const MARCA = {
  // -------------------------------------------------------------
  // Identidad del sistema
  // -------------------------------------------------------------

  // Nombre que aparece en la pestaña del navegador y en el sistema
  nombreSistema: 'Control Tóner',

  // Subtítulo que se muestra en la pantalla de inicio de sesión
  subtituloSistema: 'Sistema de Gestión de Tóner',

  // -------------------------------------------------------------
  // Datos de la empresa
  // -------------------------------------------------------------

  // Nombre de la empresa (aparece en el login y en el pie de página)
  nombreEmpresa: 'Herrera y Cía.',

  // Año de inicio para el aviso de derechos reservados
  anioCopyright: 2026,

  // -------------------------------------------------------------
  // Logo
  // -------------------------------------------------------------

  // Ruta del logo. El archivo debe estar en la carpeta `public/`.
  // Ejemplo: si pones "MiLogo.png" en public/, aquí va '/MiLogo.png'
  rutaLogo: '/Logo.png',

  // Texto alternativo del logo (accesibilidad)
  textoAltLogo: 'Logo Herrera y Cía.',

  // Imagen de fondo de la pantalla de inicio de sesión.
  // También debe estar en la carpeta `public/`.
  rutaImagenLogin: '/FondoLogin.jpg',
};

// Texto completo del pie de página con derechos reservados.
// Se calcula solo: si el año actual es mayor al de inicio, muestra un rango.
export function textoCopyright() {
  const anioActual = new Date().getFullYear();
  const rango =
    anioActual > MARCA.anioCopyright
      ? `${MARCA.anioCopyright}-${anioActual}`
      : `${MARCA.anioCopyright}`;
  return `© ${rango} ${MARCA.nombreEmpresa} Todos los derechos reservados.`;
}